import { render, staticRenderFns } from "./SettingsNotificationsPanel.vue?vue&type=template&id=13e31566"
import script from "./SettingsNotificationsPanel.vue?vue&type=script&lang=ts"
export * from "./SettingsNotificationsPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports